
    
<app-bread-crumb 
    [Locations]="[{target : '/home', label : 'Home'}]"
    current="Beachwatch partners">
</app-bread-crumb>
    
<app-hero-banner title="Beachwatch partners"></app-hero-banner>
    
<div class="nsw-container">
    <div class="nsw-layout bw-content-spacing">
        <main class="nsw-layout__main">
            <div class="nsw-block">
                <h2>About the Beachwatch Partnership Program</h2>
                <p> 
                    Strong partnerships with Beachwatch, local councils, government agencies and wastewater managers are critical to meet 
                    demand for information on safe local swim sites for communities across New South Wales. Partners are required to collect and analyse water samples for priority swim sites in their local area and provide this data for reporting within the Beachwatch program.
                    Participation in the Beachwatch Partnership Program is voluntary.
                    <br/><br/>
                    Beachwatch provides centralised coordination and data management, technical support and guidance with statewide protocols, 
                    training, quality control, audit and reporting services. Our quality assurance program ensures all data is accurate and 
                    reliable with consistent state-wide reporting compliant with the National Health and Medical Research Council guidelines.
                    <br/><br/>
                    The Beachwatch Partnership Program is an excellent way to ensure water quality is suitable for swimming and promote clean swim sites to the local community and visitors. 
                    Routine water quality monitoring also ensures swim site managers remain informed on local water quality issues.
                </p>

            </div> 

            <div class="nsw-block">
                <h2>About Beachwatch protocol</h2>
                <p> 
                    The Protocol provides practical information for our partners to design and implement programs for assessing risk from microbial contamination in recreational waters.
                    Download the <app-external-link text="Protocol for Assessment and Management of Microbial Risks in Recreational Waters" 
                        [link]="ABOUT_BEACHWATCH_PROTOCOL_URL"></app-external-link>.
                </p>
            </div> 

            <div class="nsw-block">
                <h2>Our partners</h2>
                <p>The following is a list of all partner currently monitoring water quality under the Beachwatch program.</p>               
                <div class="nsw-form__group" style="margin-top:16px;">
                    <label class="nsw-form__label" for="partnerSearchByKeyword">Keyword</label>
                    <input class="nsw-form__input" type="text" id="partnerSearchByKeyword" 
                    name="partnerSearchByKeyword" #filterCouncils placeholder="Search partner"
                    [(ngModel)]="filterText" />
                </div>                
            </div>
            
            <div class="partners-links-list">
                <div class="nsw-link-list">
                    <ul>
                        <ng-template ngFor let-item [ngForOf]="partners" let-i="index">
                            <li>
                                <a  class="linklist-item-underline-offset"
                                    [routerLink]="['/beachwatchPartners', item?.Identifier?.toString()]"
                                    [state]="{ partner : item, name : item?.PartnerName ?? '', allPartners : allPartners, allBeachSites : allBeachSites }">
                                    <span>{{item.PartnerName}}</span>
                                    <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
                                </a>
                            </li>                        
                        </ng-template>                    
                    </ul>
                </div> 
            </div>                       
        </main>

        <div class="nsw-layout__sidebar">
            <div class="nsw-link-list">
                <div class="nsw-link-list__title">Related links</div>
                <ul>
                    <li>
                        <a [href]="partnerLoginUrl" target="_blank">
                            <span>Login to partner portal</span>
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="['/contactUs']" [queryParams]="{ option : 'Partnership Interest' }">
                            <span>Join the Beachwatch program</span>
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
                        </a>
                    </li>                    
                </ul>
            </div>
        </div>
    </div>
</div>
